import { lastDays, daysIn, iso, mskToday, type Period } from '../pages/period';

/** A dated view survives links, tabs, reload and return navigation. */
export function viewPeriod(params: URLSearchParams, fallbackDays = 30, now = new Date()): Period {
  const from = params.get('from') ?? '', to = params.get('to') ?? '';
  const valid = (v: string) => /^\d{4}-\d{2}-\d{2}$/.test(v) && Number.isFinite(Date.parse(v)) && new Date(v).toISOString().slice(0, 10) === v;
  const p = { from, to };
  return valid(from) && valid(to) && daysIn(p) >= 1 && daysIn(p) <= 90 && to <= iso(mskToday(now)) ? p : lastDays(fallbackDays, now);
}

export function withPeriod(href: string, period: Period): string {
  const u = new URL(href, 'https://bidra.invalid');
  u.searchParams.set('from', period.from); u.searchParams.set('to', period.to);
  return u.pathname + u.search + u.hash;
}

export function campaignTab(params: URLSearchParams, tab: string): URLSearchParams {
  const next = new URLSearchParams(params); next.set('tab', tab); next.delete('open'); return next;
}
